import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/xgw/AXgwArticle/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/xgw/AXgwArticle/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/xgw/AXgwArticle/edit",
      {id:params}
      )
}
function SUBMIT_ADD(params) {
    return  axios.post("/xgw/AXgwArticle/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/xgw/AXgwArticle/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/xgw/AXgwArticle/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/xgw/AXgwArticle/delete",{
        params: {
            ids:params
        }
    } )
}
function LIST_ORDER (params) {
    return  axios.post("/xgw/AXgwArticle/listOrder",{list_orders:params} )
}
export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    LIST_ORDER
}